import { render, staticRenderFns } from "./popupNotification.vue?vue&type=template&id=4f8049a3&scoped=true&"
import script from "./popupNotification.vue?vue&type=script&lang=js&"
export * from "./popupNotification.vue?vue&type=script&lang=js&"
import style0 from "./popupNotification.vue?vue&type=style&index=0&id=4f8049a3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8049a3",
  null
  
)

export default component.exports